// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/common.css'
import Vuex from 'vuex'
import store from './store/index.js'
Vue.use(Vuex)

// 引入请求
import { get, post,getURL,addName } from './api/index.js'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$getURL = getURL
Vue.prototype.$addName = addName


// 轮播图插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

/* 头部组件 */
import Header from './components/header'
Vue.component(Header.name,Header)

// 底部组件
import Footer from './components/footer'
Vue.component(Footer.name,Footer)

// 移动端底部qq分享
import qq from './components/qq'
Vue.component(qq.name,qq)

// PC左侧返回顶部和分享按钮
import ShareBtn from './components/shareBtn'
Vue.component(ShareBtn.name,ShareBtn)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js